module.exports = __webpack_public_path__ + "static/media/Illus-Employee_2@3x.f75f724f.png";